import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { Autocomplete, TextField } from "@mui/material";
import { IDataFormasPagamento } from "../../types/api/financeiro/pesquisar-formas-pagamento";

export default function SelectFormaPagamento({
    value,
    onChange,
    loja_id,
    flg_usa_receber = false,
    flg_usa_pagar = false,
    flg_pix_configurado = false,
    desabilitarInput = false
}: SelectSimpleApiQueryProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-formas-pagamento", loja_id, flg_usa_receber, flg_pix_configurado, flg_usa_pagar],
        queryFn: () => axiosClient.get("/financeiro/contas-pagar/pesquisar-formas-pagamento", {
            params: {
                limit: 50,
                loja_id,
                flg_usa_receber,
                flg_pix_configurado,
                flg_usa_pagar
            }
        })
    });
    const listData: IDataFormasPagamento[] = data?.data.data || []
    //

    return (
        <Autocomplete
            disabled={isLoading || desabilitarInput}
            id="combo-box-demo"
            value={value}
            options={listData.map((i) => ({
                label: i.nome,
                id: i.id,   
                requerNsu: i.flg_cartao_credito === "S" ? true : false,
                requerChequeInfo: i.flg_cheque === "S" ? true : false
            }))}
            onChange={(_: any, newValue: TObjValueFormPagamento | null) => {
                onChange(newValue);
            }}
            renderInput={(params) => <TextField {...params} label={isLoading ? "Carregando" : "Formas de recebimento"} fullWidth />}
            clearOnEscape
        />
    )
}

interface SelectSimpleApiQueryProps {
    value: TObjValueFormPagamento | null
    onChange: (arg: TObjValueFormPagamento | null) => void,
    loja_id: number,
    flg_usa_receber?: boolean
    flg_usa_pagar?: boolean
    flg_pix_configurado?: boolean
    desabilitarInput?: boolean
}

export type TObjValueFormPagamento= {
    label: string,
    id: number,
    requerNsu: boolean,
    requerChequeInfo: boolean
    configuracoes_cartao?: ConfiguracoesCartao
    maximo_parcelas?: number;
}

type Administradora = {
    percentual: number;
    conta_contabil: number;
    centro_custo: number;
};

export type ConfiguracoesCartao = {
    tipo_publico: string;
    codigo_publico: number;
    prazo_recebimento: number;
    tipo_documento_titulo: string;
    carteira: number;
    departamento: number;
    categoria: number;
    situacao: number;
    funcao: number;
    centro_custo: number;
    administradora: Administradora;
};